import PropTypes from 'prop-types';
import cn from "../../../../utils/cn";
import { get } from 'lodash';
import RadioField from "../../../Form/RadioField/RadioField";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SHORT_LABEL_MAX_LENGTH = 40;
const columnClass = (label, isLabelColumn) => {
  const longLabel = get(label, 'length', 0) > SHORT_LABEL_MAX_LENGTH;
  return cn({
    'pr-0 pl-4': isLabelColumn,
    'col-span-4': !longLabel && isLabelColumn,
    'col-span-8': !longLabel && !isLabelColumn,
    'col-span-6': longLabel
  });
};
const ConsentTypeChoice = _ref => {
  let {
    children,
    label,
    onSelect,
    selectedType,
    type,
    dropzone = null
  } = _ref;
  const isSelected = type === selectedType;
  const onSelectHandler = () => {
    onSelect(type);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "pr-0",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "grid grid-flow-col -mx-4 items-center",
      children: [/*#__PURE__*/_jsx("div", {
        className: columnClass(label, true),
        children: /*#__PURE__*/_jsx(RadioField, {
          id: type,
          name: type,
          value: isSelected ? type : '',
          onChange: onSelectHandler,
          options: [{
            label,
            value: type
          }],
          checked: isSelected
        })
      }), isSelected ? /*#__PURE__*/_jsx("div", {
        className: columnClass(label, false),
        children: /*#__PURE__*/_jsx("div", {
          "data-testid": "children-content",
          children: children
        })
      }) : null]
    }), isSelected && dropzone ? /*#__PURE__*/_jsx("div", {
      className: "sm:w-full",
      "data-testid": "dropzone-content",
      children: dropzone
    }) : null]
  });
};
ConsentTypeChoice.propTypes = {
  /** Children content shown on the right side of the radio field */
  children: PropTypes.node.isRequired,
  /** Represents the dropzone file transfer if added */
  dropzone: PropTypes.any,
  /** Label of the RadioField */
  label: PropTypes.node.isRequired,
  /** Function when radio is selected */
  onSelect: PropTypes.func.isRequired,
  /** Value of what is currently selected via parent component */
  selectedType: PropTypes.string.isRequired,
  /** Value of ConsentTypeChoice component */
  type: PropTypes.string.isRequired
};
export default ConsentTypeChoice;
//# sourceMappingURL=ConsentTypeChoice.js.map